<template>
  <div class="factoryStatistics" ref="factoryStatistics">
    <div class="tltle">
    </div>
    <div class="fac_process">
      <ul class="fac_process_ul">
        <li class="fac_process_li" v-for="(item, n) in list" :key="n" @click="processDetail(item)">
          <div class="process_top">
            <div class="process_top_left">
              <i class="process_icon"></i>
              <div :class="[
                  'process_is_deal',
                  item.desc == '已完成'
                    ? 'process_is_deal_green'
                    : 'process_is_deal_yellow',
                ]">
                {{
                  item.desc ? item.desc : "&nbsp;&nbsp;&nbsp;--&nbsp;&nbsp;&nbsp;&nbsp;"
                }}
              </div>
              <div class="process_name">
                {{ item.typeName + " " + item.metric + ": " + item.value + item.unit }}
              </div>
              <div class="process_range_icon process_range_icon_red">超标</div>
            </div>
            <div class="process_top_right">查看详情</div>
          </div>
          <div class="process_bottom">
            <div class="process_one">
              <span class="span_label">设备名称：</span>
              <span class="span_value">{{ item.deviceName }}</span>
            </div>
            <div class="process_one">
              <span class="span_label">创建方式：</span>
              <span class="span_value">--</span>
            </div>
            <div class="process_one">
              <span class="span_label">创建时间：</span>
              <span class="span_value">{{ item.eventTime }}</span>
            </div>
          </div>
        </li>
        <!--li class="fac_process_li" v-for="i in 5" :key="i">
          <div class="process_top">
            <div class="process_top_left">
              <i class="process_icon"></i>
              <div class="process_is_deal process_is_deal_yellow">待办</div>
              <div class="process_name">微站浓度180μg/m²</div>
              <div class="process_range_icon process_range_icon_red">超标</div>
            </div>
            <div class="process_top_right">处理记录</div>
          </div>
          <div class="process_bottom">
            <div class="process_one">
              <span class="span_label">创建方式：</span>
              <span class="span_value">人工提交</span>
            </div>
            <div class="process_one">
              <span class="span_label">创建方式：</span>
              <span class="span_value">人工提交</span>
            </div>
            <div class="process_one">
              <span class="span_label">创建方式：</span>
              <span class="span_value">人工提交</span>
            </div>
          </div>
        </li-->
      </ul>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { unwarp } from "@/utils/tools.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  name: "factoryStatistics",
  components: {},
  props: ["matrix", "x", "y"],
  inject: ["updateEventData"],
  data() {
    //这里存放数据
    return {
      customerId: this.$store.state.customerId,
      chart: null,
      unit: 1,
      value: "",
      list: [],
      timer: null,
    };
  },
  //计算属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let that = this;
    let w = $(that.$refs.factoryStatistics).outerWidth();
    let h = $(that.$refs.factoryStatistics).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    this.getData();
  },
  unmounted() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
  //方法集合
  methods: {
    processDetail(item) {
      this.updateEventData(item);
    },
    check_more_click() {},
    async getData() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      let that = this;
      let getListParamPageUrl =
        CONFIG.requestName + this.$apiOpt.getListParamPage;
      this.$apiUtils
        .get(getListParamPageUrl, {
          customerId: this.$store.state.customerId,
          pageNum: 1,
          pageSize: 100,
        })
        .then(function (data) {
          that.list = data.list;
          that.list.forEach((item) => {
            item.eventTime = that
              .$moment(item.eventTime)
              .format("YYYY-MM-DD hh:mm");
          });
          that.$forceUpdate();
        });

      that.timer = setTimeout(function () {
        that.getData();
      }, 60000);
    },
  },
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped="scoped">
.factoryStatistics {
  position: relative;
  padding: 0px 20px !important;
  .tltle {
    display: flex;
    justify-content: flex-end;
    padding: 20px 0;
    .check_more {
      width: 152px;
      height: 47px;
      line-height: 47px;
      background: linear-gradient(85deg, #016fd1 0%, #024083 100%);
      border-radius: 6px;
      font-size: 28px;
      text-align: center;
    }
  }
  .fac_block {
    display: flex;
    justify-content: space-between;
    & > li:first-of-type {
      width: 25%;
    }
    li {
      width: 18%;
      max-height: 160px;
      overflow: auto;
      padding: 10px 15px;
      text-align: center;
      background-color: rgba(0, 24, 56, 0.7);
      border-radius: 6px;
      .fac_block_name {
        color: #8cd7fa;
        font-size: 18px;
      }
      .fac_block_count {
        font-size: 36px;
        font-weight: 500;
        color: #65f5f2;
        text-shadow: 0px 2px 6px #0091ff;
        margin-bottom: 20px;
      }
      .fac_process_box {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .fac_deal_bar {
          // width: 131px;
          width: 90%;
          height: 5px;
          background: #44d7b6;
          border-radius: 3px;
          margin-right: 10px;
        }
        .fac_undeal_bar {
          background: rgba(255, 189, 75, 1);
        }
        .fac_deal_count {
          color: #8cd7fa;
          font-size: 18px;
        }
      }
    }
  }
  .fac_process {
    padding: 20px 10px;
    height: 640px;
    overflow: auto;
    .fac_process_ul {
      .fac_process_li {
        .process_top {
          display: flex;
          justify-content: space-between;
          margin-bottom: 20px;
          .process_top_left {
            display: flex;
            align-items: center;
            .process_icon {
              width: 15px;
              height: 15px;
              background: #566d90;
              border-radius: 50%;
              margin-right: 20px;
            }
            .process_is_deal {
              padding: 3px 10px;
              border-radius: 6px;
              margin-right: 10px;
            }
            .process_is_deal_yellow {
              color: rgba(247, 181, 0, 1);
              border: 1px solid rgba(247, 181, 0, 1);
            }
            .process_is_deal_green {
              color: rgba(68, 215, 182, 1);
              border: 1px solid rgba(68, 215, 182, 1);
            }
            .process_name {
              font-size: 28px;
            }
            .process_range_icon {
              padding: 2px 8px 2px 15px;
              margin-left: 10px;
              clip-path: polygon(15% 0, 100% 0, 100% 100%, 15% 100%, 0 50%);
            }
            .process_range_icon_red {
              background-color: rgba(255, 77, 77, 1);
            }
            .process_range_icon_grey {
              background-color: rgba(101, 101, 101, 1);
            }
          }
          .process_top_right {
            width: 141px;
            height: 33px;
            line-height: 33px;
            background: linear-gradient(85deg, #016fd1 0%, #024083 100%);
            border-radius: 6px;
            font-size: 24px;
            text-align: center;
          }
        }
        .process_bottom {
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          padding-left: 37px;
          margin-bottom: 20px;
          .process_one {
            margin-right: 25px;
            span {
              font-size: 22px;
              color: #8fdcff;
            }
          }
        }
      }
    }
  }
}
</style>
